import { render, staticRenderFns } from "./AccountingPointTable.vue?vue&type=template&id=1ca7e89f&"
import script from "./AccountingPointTable.vue?vue&type=script&lang=ts&"
export * from "./AccountingPointTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports